import Swal from 'sweetalert2';

function Alert_Modals() {
  // Function to display the alert based on the type
  const showAlert = (text, type,place) => {
    if (type === "error") {
      return Swal.fire({
        icon: "error",
        width:"400px",
        title: "Oops...",
        position:place,
        text: text,
        confirmButtonColor: '#d33',
        background: '#fff5f5',
        showConfirmButton: true,
      });
    } else if (type === "success") {
      return Swal.fire({
        icon: 'success',
        width:"400px",
        title: 'Success!',
        position:place,
        text: text,
        confirmButtonColor: '#28a745',
        background: '#f0fff4',
        showConfirmButton: false,
        timer: 2000
      });
    } else if (type === "warning") {
      return Swal.fire({
        icon: 'warning',
        width:"400px",
        title: 'Warning!',
        position:place,
        text: text,
        confirmButtonColor: '#ffc107',
        background: '#fffaf0',
        showConfirmButton: false,
        timer: 2500
      });
    }
  };

  // Return the function to be used in the parent component
  return { showAlert };
}

export default Alert_Modals;